export default "__VITE_ASSET__CA4gywjx__"